// 폴리필 파일 - 빌드 과정에서 제거되지 않도록 보장
import "reflect-metadata";

// reflect-metadata가 제대로 로드되었는지 확인
if (typeof Reflect === "undefined" || !Reflect.getMetadata) {
    throw new Error("reflect-metadata polyfill is required");
}

console.log("reflect-metadata polyfill loaded successfully");
